import { PureComponent } from 'react'

export class ResetSystem extends PureComponent {
    render() {
        return (
            <h2>Auswertungsmaschine zur&uuml;ckgesetzt!</h2>
        )
    }
}